/* script */
//
//
//
//
//
//
//
//

// Components
import RegistrationType from 'shared/ui/components/registrations/RegistrationType.vue';
import RegistrationUrlPicker from 'shared/ui/components/form-components/pickers/RegistrationUrlPicker.vue';

const __vue_script__ = {
    name: 'ActivationForm',

    components: { RegistrationType, RegistrationUrlPicker },

    props: {
        event: {
            type: Object,
            required: true
        },

        eventDetails: {
            type: Object,
            default: () => ({})
        },

        settings: {
            type: Object,
            default: () => ({
                access_type: 'public'
            })
        }
    },

    data() {
        const eventName = this.$utils.workspaces.getWorkspaceTitle(this.event);
        const defaultUrl = this.$utils.strings.parameterize(eventName);
        return {
            registrationType: this.settings.access_type,
            registrationUrl: this.eventDetails.path_name || defaultUrl
        };
    },

    computed: {
        /** @returns {string} */
        urlPreview() {
            const orgName = this.$services.org.getDisplayName(this.event.ownerId);
            const path = this.registrationUrl;
            const url = this.$utils.url.getWebappRegistrationUrl(orgName, path, false, this.event.white_label_domain);
            return this.$i18n.t('registration.activation.url_preview', [url]).toString();
        }
    },

    methods: {
        async activate() {
            let succeed = false;
            try {
                const data = await this.$services.pax.enableRegistration(this.event._id, {
                    path_name: this.registrationUrl,
                    access_type: this.registrationType
                });
                await this.$services.metadata.getMetadata(this.event._id, 0);
                if (data) {
                    this.$emit('updated');
                    succeed = true;
                }
            } catch (error) {
                console.error('[ActivationFrom] Could not activate the registration page', error.message);
            } finally {
                if (!succeed) {
                    this.$notify({
                        group: 'flashes',
                        text: this.$i18n.t('registration.activation.messages.activation_failed').toString(),
                        type: 'error'
                    });
                }
            }
        }
    }
};

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('validation-observer',{attrs:{"slim":true},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var handleSubmit = ref.handleSubmit;
var invalid = ref.invalid;
return [_c('form',{staticClass:"activation-form",on:{"submit":function($event){$event.preventDefault();return handleSubmit(_vm.activate)}}},[(_vm.settings.registration_type_enabled)?_c('registration-type',{attrs:{"name":"registrationType"},model:{value:(_vm.registrationType),callback:function ($$v) {_vm.registrationType=$$v},expression:"registrationType"}}):_vm._e(),_c('registration-url-picker',{attrs:{"event":_vm.event,"name":"registrationUrl","placeholder":_vm.$t('registration.activation.reg_url')},model:{value:(_vm.registrationUrl),callback:function ($$v) {_vm.registrationUrl=$$v},expression:"registrationUrl"}},[_c('button',{staticClass:"btn btn-primary",attrs:{"disabled":invalid}},[_vm._v(_vm._s(_vm.$t('registration.activation.activate')))])])],1)]}}])})}
var __vue_staticRenderFns__ = []

  /* style */
  const __vue_inject_styles__ = undefined
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "ActivationForm.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (false) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  )

  export default __vue_component__